import {ProjectCareSubRegimeDomiciliary} from '@/features/projects/components/project-form/project-care-fields/ProjectCareSubRegimeDomiciliary'
import {ProjectCareSubRegimeEmpty} from '@/features/projects/components/project-form/project-care-fields/ProjectCareSubRegimeEmpty'
import {ProjectCareSubRegimeOutpatient} from '@/features/projects/components/project-form/project-care-fields/ProjectCareSubRegimeOutpatient'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const ProjectCareSubRegimeFieldsSchema = ProjectFieldsSchema.pick({
    sector: true
})
type ProjectCareSubRegimeFieldsSchema = z.infer<typeof ProjectCareSubRegimeFieldsSchema>

export const ProjectCareSubRegimeFields = () => {
    const {control} = useFormContext<ProjectCareSubRegimeFieldsSchema>()
    const sector = useWatch({control, name: 'sector'})

    if (sector == 'domiciliary') {
        return <ProjectCareSubRegimeDomiciliary />
    }

    if (sector == 'outpatient' || sector == 'mixed') {
        return <ProjectCareSubRegimeOutpatient />
    }

    return <ProjectCareSubRegimeEmpty />
}
